"use strict";

var _asyncToGenerator = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");
var _inherits = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _createSuper = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");
var _createClass = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TwilsockImpl = exports.TwilsockChannel = exports.Response = void 0;
var events_1 = require("events");
var StateMachine = require("javascript-state-machine");
var logger_1 = require("./logger");
var Messages = require("./protocol/messages");
var parser_1 = require("./parser");
var twilsockreplyerror_1 = require("./error/twilsockreplyerror");
var backoffretrier_1 = require("./backoffretrier");
var DISCONNECTING_TIMEOUT = 3000;
// Wraps asynchronous rescheduling
// Just makes it simpler to find these hacks over the code
function trampoline(f) {
  setTimeout(f, 0);
}
/**
 * Makes sure that body is properly stringified
 */
function preparePayload(payload) {
  switch (typeof payload) {
    case 'undefined':
      return '';
    case 'object':
      return JSON.stringify(payload);
    default:
      return payload;
  }
}
var Request = /*#__PURE__*/_createClass(function Request() {
  _classCallCheck(this, Request);
});
var Response = /*#__PURE__*/_createClass(function Response() {
  _classCallCheck(this, Response);
});
exports.Response = Response;
/**
 * Twilsock channel level protocol implementation
 */
var TwilsockChannel = /*#__PURE__*/function (_events_1$EventEmitte) {
  _inherits(TwilsockChannel, _events_1$EventEmitte);
  var _super = _createSuper(TwilsockChannel);
  function TwilsockChannel(websocket, transport, config) {
    var _this;
    _classCallCheck(this, TwilsockChannel);
    _this = _super.call(this);
    _this.terminalStates = ['disconnected', 'rejected'];
    _this.lastEmittedState = undefined;
    _this.tokenExpiredSasCode = 20104;
    _this.terminationReason = 'Connection is not initialized';
    _this.websocket = websocket;
    _this.websocket.on('connected', function () {
      return _this.fsm.socketConnected();
    });
    _this.websocket.on('disconnected', function (e) {
      return _this.fsm.socketClosed();
    });
    _this.websocket.on('message', function (message) {
      return _this.onIncomingMessage(message);
    });
    _this.websocket.on('socketError', function (e) {
      return _this.emit('connectionError', {
        terminal: false,
        message: e.message,
        httpStatusCode: null,
        errorCode: null
      });
    });
    _this.transport = transport;
    _this.config = config;
    _this.retrier = new backoffretrier_1.BackoffRetrier(config.retryPolicy);
    _this.retrier.on('attempt', function () {
      return _this.retry();
    });
    _this.retrier.on('failed', function (err) {
      logger_1.log.warn("Retrying failed: ".concat(err.message));
      _this.disconnect();
    });
    if (typeof window !== 'undefined' && typeof window.addEventListener !== 'undefined') {
      window.addEventListener('online', function () {
        logger_1.log.debug('Browser reported connectivity state: online');
        _this.fsm.systemOnline();
      });
      window.addEventListener('offline', function () {
        logger_1.log.debug('Browser reported connectivity state: offline');
        _this.websocket.close();
        _this.fsm.socketClosed();
      });
    }
    _this.fsm = new StateMachine({
      init: 'disconnected',
      transitions: [{
        name: 'userConnect',
        from: ['disconnected', 'rejected'],
        to: 'connecting'
      }, {
        name: 'userConnect',
        from: ['connecting', 'connected']
      }, {
        name: 'userDisconnect',
        from: ['connecting', 'initialising', 'connected', 'updating', 'retrying', 'rejected', 'waitSocketClosed', 'waitOffloadSocketClosed'],
        to: 'disconnecting'
      }, {
        name: 'userRetry',
        from: ['retrying'],
        to: 'connecting'
      }, {
        name: 'socketConnected',
        from: ['connecting'],
        to: 'initialising'
      }, {
        name: 'socketClosed',
        from: ['connecting', 'initialising', 'connected', 'updating', 'error', 'waitOffloadSocketClosed'],
        to: 'retrying'
      }, {
        name: 'socketClosed',
        from: ['disconnecting'],
        to: 'disconnected'
      }, {
        name: 'socketClosed',
        from: ['waitSocketClosed'],
        to: 'disconnected'
      }, {
        name: 'socketClosed',
        from: ['rejected'],
        to: 'rejected'
      }, {
        name: 'initSuccess',
        from: ['initialising'],
        to: 'connected'
      }, {
        name: 'initError',
        from: ['initialising'],
        to: 'error'
      }, {
        name: 'tokenRejected',
        from: ['initialising', 'updating'],
        to: 'rejected'
      }, {
        name: 'protocolError',
        from: ['initialising', 'connected', 'updating'],
        to: 'error'
      }, {
        name: 'receiveClose',
        from: ['initialising', 'connected', 'updating'],
        to: 'waitSocketClosed'
      }, {
        name: 'receiveOffload',
        from: ['initialising', 'connected', 'updating'],
        to: 'waitOffloadSocketClosed'
      }, {
        name: 'unsupportedProtocol',
        from: ['initialising', 'connected', 'updating'],
        to: 'unsupported'
      }, {
        name: 'receiveFatalClose',
        from: ['initialising', 'connected', 'updating'],
        to: 'unsupported'
      }, {
        name: 'userUpdateToken',
        from: ['disconnected', 'rejected', 'connecting', 'retrying'],
        to: 'connecting'
      }, {
        name: 'userUpdateToken',
        from: ['connected'],
        to: 'updating'
      }, {
        name: 'updateSuccess',
        from: ['updating'],
        to: 'connected'
      }, {
        name: 'updateError',
        from: ['updating'],
        to: 'error'
      }, {
        name: 'userSend',
        from: ['connected'],
        to: 'connected'
      }, {
        name: 'systemOnline',
        from: ['retrying'],
        to: 'connecting'
      }],
      methods: {
        onConnecting: function onConnecting() {
          _this.setupSocket();
          _this.emit('connecting');
        },
        onEnterInitialising: function onEnterInitialising() {
          _this.sendInit();
        },
        onLeaveInitialising: function onLeaveInitialising() {
          _this.cancelInit();
        },
        onEnterUpdating: function onEnterUpdating() {
          _this.sendUpdate();
        },
        onLeaveUpdating: function onLeaveUpdating() {
          _this.cancelUpdate();
        },
        onEnterRetrying: function onEnterRetrying() {
          _this.initRetry();
          _this.emit('connecting');
        },
        onEnterConnected: function onEnterConnected() {
          _this.resetBackoff();
          _this.onConnected();
        },
        onUserUpdateToken: function onUserUpdateToken() {
          _this.resetBackoff();
        },
        onTokenRejected: function onTokenRejected() {
          _this.resetBackoff();
          _this.closeSocket(true);
          _this.finalizeSocket();
        },
        onUserDisconnect: function onUserDisconnect() {
          _this.closeSocket(true);
        },
        onEnterDisconnecting: function onEnterDisconnecting() {
          _this.startDisconnectTimer();
        },
        onLeaveDisconnecting: function onLeaveDisconnecting() {
          _this.cancelDisconnectTimer();
        },
        onEnterWaitSocketClosed: function onEnterWaitSocketClosed() {
          _this.startDisconnectTimer();
        },
        onLeaveWaitSocketClosed: function onLeaveWaitSocketClosed() {
          _this.cancelDisconnectTimer();
        },
        onEnterWaitOffloadSocketClosed: function onEnterWaitOffloadSocketClosed() {
          _this.startDisconnectTimer();
        },
        onLeaveWaitOffloadSocketClosed: function onLeaveWaitOffloadSocketClosed() {
          _this.cancelDisconnectTimer();
        },
        onDisconnected: function onDisconnected() {
          _this.resetBackoff();
          _this.finalizeSocket();
        },
        onReceiveClose: function onReceiveClose(event, args) {
          _this.onCloseReceived(args);
        },
        onReceiveOffload: function onReceiveOffload(event, args) {
          logger_1.log.debug('onreceiveoffload: ', args);
          _this.modifyBackoff(args.body);
          _this.onCloseReceived(args.status);
        },
        onUnsupported: function onUnsupported() {
          _this.closeSocket(true);
          _this.finalizeSocket();
        },
        onError: function onError(lifecycle, graceful) {
          _this.closeSocket(graceful);
          _this.finalizeSocket();
        },
        onEnterState: function onEnterState(event) {
          if (event.from !== 'none') {
            _this.changeState(event);
          }
        },
        onInvalidTransition: function onInvalidTransition(transition, from, to) {
          logger_1.log.warn('FSM: unexpected transition', from, to);
        }
      }
    });
    return _this;
  }
  _createClass(TwilsockChannel, [{
    key: "changeState",
    value: function changeState(event) {
      logger_1.log.debug("FSM: ".concat(event.transition, ": ").concat(event.from, " --> ").concat(event.to));
      if (this.lastEmittedState !== this.state) {
        this.lastEmittedState = this.state;
        this.emit('stateChanged', this.state);
      }
    }
  }, {
    key: "resetBackoff",
    value: function resetBackoff() {
      logger_1.log.trace('resetBackoff');
      this.retrier.stop();
    }
  }, {
    key: "modifyBackoff",
    value: function modifyBackoff(body) {
      logger_1.log.trace('modifyBackoff', body);
      var backoffPolicy = body ? body.backoff_policy : null;
      if (backoffPolicy && typeof backoffPolicy.reconnect_min_ms === 'number') {
        this.retrier.modifyBackoff(backoffPolicy.reconnect_min_ms);
      }
    }
  }, {
    key: "startDisconnectTimer",
    value: function startDisconnectTimer() {
      var _this2 = this;
      logger_1.log.trace('startDisconnectTimer');
      if (this.disconnectingTimer) {
        clearTimeout(this.disconnectingTimer);
        this.disconnectingTimer = null;
      }
      this.disconnectingTimer = setTimeout(function () {
        logger_1.log.debug('disconnecting is timed out');
        _this2.closeSocket(true);
      }, DISCONNECTING_TIMEOUT);
    }
  }, {
    key: "cancelDisconnectTimer",
    value: function cancelDisconnectTimer() {
      logger_1.log.trace('cancelDisconnectTimer');
      if (this.disconnectingTimer) {
        clearTimeout(this.disconnectingTimer);
        this.disconnectingTimer = null;
      }
    }
  }, {
    key: "isConnected",
    get: function get() {
      return this.state === 'connected' && this.websocket.isConnected;
    }
  }, {
    key: "state",
    get: function get() {
      switch (this.fsm.state) {
        case 'connecting':
        case 'initialising':
        case 'retrying':
        case 'error':
          return 'connecting';
        case 'updating':
        case 'connected':
          return 'connected';
        case 'rejected':
          return 'rejected';
        case 'disconnecting':
        case 'waitSocketClosed':
        case 'waitOffloadSocketClosed':
          return 'disconnecting';
        case 'disconnected':
        default:
          return 'disconnected';
      }
    }
  }, {
    key: "initRetry",
    value: function initRetry() {
      logger_1.log.debug('initRetry');
      if (this.retrier.inProgress) {
        this.retrier.attemptFailed();
      } else {
        this.retrier.start();
      }
    }
  }, {
    key: "retry",
    value: function retry() {
      if (this.fsm.state != 'connecting') {
        logger_1.log.trace('retry');
        this.websocket.close();
        this.fsm.userRetry();
      } else {
        logger_1.log.trace('can\t retry as already connecting');
      }
    }
  }, {
    key: "onConnected",
    value: function onConnected() {
      this.emit('connected');
    }
  }, {
    key: "finalizeSocket",
    value: function finalizeSocket() {
      logger_1.log.trace('finalizeSocket');
      this.websocket.close();
      this.emit('disconnected');
      if (this.disconnectedPromiseResolve) {
        this.disconnectedPromiseResolve();
        this.disconnectedPromiseResolve = null;
      }
    }
  }, {
    key: "setupSocket",
    value: function setupSocket() {
      logger_1.log.trace('setupSocket:', this.config.token);
      this.emit('beforeConnect'); // This is used by client to record startup telemetry event
      this.websocket.connect();
    }
  }, {
    key: "onIncomingMessage",
    value: function onIncomingMessage(message) {
      var _parser_1$Parser$pars = parser_1.Parser.parse(message),
        method = _parser_1$Parser$pars.method,
        header = _parser_1$Parser$pars.header,
        payload = _parser_1$Parser$pars.payload;
      if (method !== 'reply') {
        this.confirmReceiving(header);
      }
      if (method === 'notification') {
        this.emit('message', header.message_type, payload);
      } else if (header.method === 'reply') {
        this.transport.processReply({
          id: header.id,
          status: header.status,
          header: header,
          body: payload
        });
      } else if (header.method === 'client_update') {
        if (header.client_update_type === 'token_about_to_expire') {
          this.emit('tokenAboutToExpire');
        }
      } else if (header.method === 'close') {
        if (header.status.code === 308) {
          logger_1.log.debug('Connection has been offloaded');
          this.fsm.receiveOffload({
            status: header.status.status,
            body: payload
          });
        } else if (header.status.code === 406) {
          // Not acceptable message
          var _message = "Server closed connection because can't parse protocol: ".concat(JSON.stringify(header.status));
          this.emitReplyConnectionError(_message, header, true);
          logger_1.log.error(_message);
          this.fsm.receiveFatalClose();
        } else if (header.status.code === 417) {
          // Protocol error
          logger_1.log.error("Server closed connection because can't parse client reply: ".concat(JSON.stringify(header.status)));
          this.fsm.receiveFatalClose(header.status.status);
        } else if (header.status.code === 410) {
          // Expired token
          logger_1.log.warn("Server closed connection: ".concat(JSON.stringify(header.status)));
          this.fsm.receiveClose(header.status.status);
          this.emit('tokenExpired');
        } else if (header.status.code === 401) {
          // Authentication fail
          logger_1.log.error("Server closed connection: ".concat(JSON.stringify(header.status)));
          this.fsm.receiveClose(header.status.status);
        } else {
          logger_1.log.warn('unexpected message: ', header.status);
          // Try to reconnect
          this.fsm.receiveOffload({
            status: header.status.status,
            body: null
          });
        }
      }
    }
  }, {
    key: "sendInit",
    value: function () {
      var _sendInit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var reply, isTerminalError;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              logger_1.log.trace('sendInit');
              _context.prev = 1;
              this.emit('beforeSendInit'); // This is used by client to record startup telemetry event
              _context.next = 5;
              return this.transport.sendInit();
            case 5:
              reply = _context.sent;
              this.config.updateContinuationToken(reply.continuationToken);
              this.config.confirmedCapabilities = reply.confirmedCapabilities;
              this.fsm.initSuccess(reply);
              this.emit('initialized', reply);
              this.emit('tokenUpdated');
              _context.next = 17;
              break;
            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](1);
              if (_context.t0 instanceof twilsockreplyerror_1.TwilsockReplyError) {
                isTerminalError = false;
                logger_1.log.warn("Init rejected by server: ".concat(JSON.stringify(_context.t0.reply.status)));
                this.emit('sendInitFailed'); // This is used by client to record startup telemetry event
                // @todo emit telemetry from inside "if" below for more granularity...
                if (_context.t0.reply.status.code === 401 || _context.t0.reply.status.code === 403) {
                  isTerminalError = true;
                  this.fsm.tokenRejected(_context.t0.reply.status);
                  if (_context.t0.reply.status.errorCode === this.tokenExpiredSasCode) {
                    this.emit('tokenExpired');
                  }
                } else if (_context.t0.reply.status.code === 429) {
                  this.modifyBackoff(_context.t0.reply.body);
                  this.fsm.initError(true);
                } else if (_context.t0.reply.status.code === 500) {
                  this.fsm.initError(false);
                } else {
                  this.fsm.initError(true);
                }
                this.emitReplyConnectionError(_context.t0.message, _context.t0.reply, isTerminalError);
              } else {
                this.terminationReason = _context.t0.message;
                this.emit('connectionError', {
                  terminal: true,
                  message: _context.t0.message,
                  httpStatusCode: null,
                  errorCode: null
                });
                this.fsm.initError(true);
              }
              this.emit('tokenUpdated', _context.t0);
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1, 13]]);
      }));
      function sendInit() {
        return _sendInit.apply(this, arguments);
      }
      return sendInit;
    }()
  }, {
    key: "sendUpdate",
    value: function () {
      var _sendUpdate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var message, reply, isTerminalError;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              logger_1.log.trace('sendUpdate');
              message = new Messages.Update(this.config.token);
              _context2.prev = 2;
              _context2.next = 5;
              return this.transport.sendWithReply(message);
            case 5:
              reply = _context2.sent;
              this.fsm.updateSuccess(reply.body);
              this.emit('tokenUpdated');
              _context2.next = 14;
              break;
            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](2);
              if (_context2.t0 instanceof twilsockreplyerror_1.TwilsockReplyError) {
                isTerminalError = false;
                logger_1.log.warn("Token update rejected by server: ".concat(JSON.stringify(_context2.t0.reply.status)));
                if (_context2.t0.reply.status.code === 401 || _context2.t0.reply.status.code === 403) {
                  isTerminalError = true;
                  this.fsm.tokenRejected(_context2.t0.reply.status);
                  if (_context2.t0.reply.status.errorCode === this.tokenExpiredSasCode) {
                    this.emit('tokenExpired');
                  }
                } else if (_context2.t0.reply.status.code === 429) {
                  this.modifyBackoff(_context2.t0.reply.body);
                  this.fsm.updateError(_context2.t0.reply.status);
                } else {
                  this.fsm.updateError(_context2.t0.reply.status);
                }
                this.emitReplyConnectionError(_context2.t0.message, _context2.t0.reply, isTerminalError);
              } else {
                this.emit('error', false, _context2.t0.message, null, null);
                this.fsm.updateError(_context2.t0);
              }
              this.emit('tokenUpdated', _context2.t0);
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[2, 10]]);
      }));
      function sendUpdate() {
        return _sendUpdate.apply(this, arguments);
      }
      return sendUpdate;
    }()
  }, {
    key: "emitReplyConnectionError",
    value: function emitReplyConnectionError(message, header, terminal) {
      var description = header.status && header.status.description ? header.status.description : message;
      var httpStatusCode = header.status.code;
      var errorCode = header.status && header.status.errorCode ? header.status.errorCode : null;
      if (terminal) {
        this.terminationReason = description;
      }
      this.emit('connectionError', {
        terminal: terminal,
        message: description,
        httpStatusCode: httpStatusCode,
        errorCode: errorCode
      });
    }
  }, {
    key: "cancelInit",
    value: function cancelInit() {
      logger_1.log.trace('cancelInit');
      // TODO: implement
    }
  }, {
    key: "cancelUpdate",
    value: function cancelUpdate() {
      logger_1.log.trace('cancelUpdate');
      // TODO: implement
    }
    /**
     * Should be called for each message to confirm it received
     */
  }, {
    key: "confirmReceiving",
    value: function confirmReceiving(messageHeader) {
      logger_1.log.trace('confirmReceiving');
      try {
        //@todo send telemetry events AnyEvents
        this.transport.send(new Messages.Reply(messageHeader.id));
      } catch (e) {
        logger_1.log.debug('failed to confirm packet receiving', e);
      }
    }
    /**
     * Shutdown connection
     */
  }, {
    key: "closeSocket",
    value: function closeSocket(graceful) {
      var _this3 = this;
      logger_1.log.trace("closeSocket (graceful: ".concat(graceful, ")"));
      if (graceful && this.transport.isConnected) {
        this.transport.sendClose();
      }
      this.websocket.close();
      trampoline(function () {
        return _this3.fsm.socketClosed();
      });
    }
    /**
     * Initiate the twilsock connection
     * If already connected, it does nothing
     */
  }, {
    key: "connect",
    value: function connect() {
      logger_1.log.trace('connect');
      this.fsm.userConnect();
    }
    /**
     * Close twilsock connection
     * If already disconnected, it does nothing
     */
  }, {
    key: "disconnect",
    value: function disconnect() {
      var _this4 = this;
      logger_1.log.trace('disconnect');
      if (this.fsm.is('disconnected')) {
        return Promise.resolve();
      }
      return new Promise(function (resolve) {
        _this4.disconnectedPromiseResolve = resolve;
        _this4.fsm.userDisconnect();
      });
    }
    /**
     * Update fpa token for twilsock connection
     */
  }, {
    key: "updateToken",
    value: function updateToken(token) {
      var _this5 = this;
      logger_1.log.trace('updateToken:', token);
      return new Promise(function (resolve, reject) {
        _this5.once('tokenUpdated', function (e) {
          if (e) {
            reject(e);
          } else {
            resolve();
          }
        });
        _this5.fsm.userUpdateToken();
      });
    }
  }, {
    key: "isTerminalState",
    get: function get() {
      return this.terminalStates.indexOf(this.fsm.state) !== -1;
    }
  }, {
    key: "getTerminationReason",
    get: function get() {
      return this.terminationReason;
    }
  }, {
    key: "onCloseReceived",
    value: function onCloseReceived(reason) {
      this.websocket.close();
    }
  }]);
  return TwilsockChannel;
}(events_1.EventEmitter);
exports.TwilsockChannel = TwilsockChannel;
exports.TwilsockImpl = TwilsockChannel;